import reducer from './reducer';
import sagas from './sagas';

export const messagesReducer = reducer;
export const messagesSagas = sagas;

export * as MessagesActions from './actions';
export * as MessagesSelectors from './selectors';

